import { Device } from "../model/Device";
import { makeDeviceCache } from "./storage/cache";
import { DriveStore } from "../store/reducers";
import { vehicleHistoryActions } from "../store/vehicleHistory/actions";
import { TVehicle } from "../store/vehicleHistory/types";
import { extend } from "./vanilla";
import { MobileActions } from "../store/mobile/actions";

let currentVehicle: IIdEntity | null;
let previousVehicle: IIdEntity | null;

export function getCurrentVehicle(store?: DriveStore): IIdEntity | null {
    // Right after reload, window.driveApp is undefined, we have to reconsider this approach based on use case
    const driveStore: DriveStore = store ?? window.driveApp?.store;

    if (driveStore && (!currentVehicle || !currentVehicle.id)) {
        let storeCurrentVehicle = driveStore.getState().vehicleHistory.currentVehicle;
        if (storeCurrentVehicle) {
            currentVehicle = extend(true, {}, storeCurrentVehicle);
        }
    }

    return currentVehicle?.id ? { id: currentVehicle.id } : null;
}

export function getCurrentVehicleName(store: DriveStore): string | null {
    const currentDeviceId = getCurrentVehicle();
    if (!currentDeviceId) {
        return null;
    }

    return (makeDeviceCache(store).get(currentDeviceId)[0] as Device)?.name ?? null;
}

export function setCurrentVehicle(newValue: IIdEntity): void {
    if (!newValue || !newValue.id) {
        throw new Error("Invalid current vehicle");
    }
    const store: DriveStore = window.driveApp?.store;
    if (store) {
        store.dispatch(vehicleHistoryActions.setCurrentVehicle({ currentVehicle: newValue }));
        // Clear DeviceStatusInfo information when changing current vehicle
        store.dispatch(MobileActions.setDeviceCommunicating(undefined));
    }
    currentVehicle = extend(true, {}, newValue);
}

export function clearCurrentVehicle(): void {
    const store: DriveStore = window.driveApp?.store;
    if (store) {
        store.dispatch(vehicleHistoryActions.clearCurrentVehicle());
        // Clear DeviceStatusInfo information when clearing current vehicle
        store.dispatch(MobileActions.setDeviceCommunicating(undefined));
    }
    currentVehicle = null;
}

export function isNoVehicle(): boolean {
    let vehicle = getCurrentVehicle();

    return !vehicle || (vehicle && vehicle.id === "NoDeviceId");
}

export function isSleeperBerthDisabled(store: DriveStore, deviceToCheck?: IIdEntity | null | "NoDeviceId"): boolean {
    let deviceId: IIdEntity | null;
    if (!deviceToCheck || deviceToCheck === "NoDeviceId") {
        deviceId = getCurrentVehicle();
    } else {
        deviceId = deviceToCheck;
    }
    let device = makeDeviceCache(store).get(deviceId)[0] as Device;
    if (device && device.disableSleeperBerth) {
        return true;
    }
    return false;
}

export function getPreviousVehicle(): TVehicle {
    const store: DriveStore = window.driveApp?.store;
    if (store && (!previousVehicle || !previousVehicle.id)) {
        let storePreviousVehicle = store.getState().vehicleHistory.previousVehicle;
        if (storePreviousVehicle) {
            previousVehicle = extend(true, {}, storePreviousVehicle);
        }
    }

    return previousVehicle?.id ? { id: previousVehicle.id } : null;
}

export function setPreviousVehicle(newValue: IIdEntity): void {
    const store: DriveStore = window.driveApp?.store;
    if (!newValue || !newValue.id) {
        throw new Error("Invalid previous vehicle");
    }
    store?.dispatch(vehicleHistoryActions.setPreviousVehicle({ previousVehicle: newValue }));
    previousVehicle = extend(true, {}, newValue);
}

export function clearPreviousVehicle(): void {
    const store: DriveStore = window.driveApp?.store;
    store?.dispatch(vehicleHistoryActions.clearPreviousVehicle());
    previousVehicle = null;
}
